import {basePostRequest} from "../base/basePostRequest";

const postProjectApplications = async (
  id_project: number,
  applications: Array<{id_app: number | string}>
) => basePostRequest<{}>(`/project/${id_project}/application/`, applications);

export default postProjectApplications;
